import { Component, Injectable, OnInit, Input, Compiler } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../../../../../app/services/authentication.service';
import { AlertService } from '../../../../../../app/utils/alert.service';
import { BindComponentService } from "../../../../../../app/utils/bind.component.service";
import { Router, NavigationEnd } from "@angular/router";

/**
 * @version $Id: content.component.ts 62312 2017-09-12 17:39:13Z bernardo.d.siqueira $
 */
@Component({
  selector: 'HibridModalComponent',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class HibridModalComponent implements OnInit {

  @Input() textHibrid: string;


  constructor(private activeModal: NgbActiveModal,
    private authService: AuthenticationService,
    private alertService: AlertService,
    private router: Router,  
    private bindComponent: BindComponentService
    ) {
  } 

  ngOnInit() {
   
  };

  private close() {
    this.activeModal.dismiss();
  }

  private getWelcomeText() {
    this.authService.getWelcomeText().subscribe(
      data => {
        //console.log("hibridText")
        this.textHibrid = data['hibridText'];
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  public redirect(andress:string){
    this.router.navigate([andress], { queryParams: {openLine:true} });
    this.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/welcome/hibridModal/content.component.ts